var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.buttonContent.label)?_c('a',{staticClass:"button",attrs:{"href":_vm.buttonContent.url}},[_vm._v(" "+_vm._s(_vm.buttonContent.label)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }